import React from 'react';
import cn from 'classnames';
import Link from 'next/link';

import styles from './ExampleContent.module.css';

const Buttons = props => (
  <div className="absolute bottom-0 right-0 pb-4 pr-4">
    {props.landingHref && (
      <Button className="mr-2" bg="bg-neutral-200" textColor="text-black">
        <Link href={props.landingHref} className="text-black">
          Learn More
        </Link>
      </Button>
    )}
    {props.hideRunCode && (
      <div className="absolute scale-75 bottom-2 right-3">
        <svg className={styles.checkmark} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
          <circle className={styles.checkmarkCircle} cx="26" cy="26" r="25" fill="none" />
          <path className={styles.checkmarkCheck} fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
        </svg>
      </div>
    )}
    <Button
      bg="bg-black"
      textColor="text-white"
      loading={props.hideRunCode}
      onClick={e => props.handleClick(e)}
      highlighted={props.highlighted}
    >
      {props.buttonText}
    </Button>
  </div>
);

const Button = ({ children, className, bg, textColor, loading, onClick, highlighted }) =>
  !highlighted ? (
    <div
      onClick={onClick}
      className={cn(
        className,
        bg,
        textColor,
        { 'transform translate-y-3 opacity-0': loading },
        'text-md font-medium whitespace-nowrap uppercase py-2 px-4 rounded-full cursor-pointer transition-all duration-500'
      )}
    >
      {children}
    </div>
  ) : (
    <button
      type="button"
      className={cn(
        className,
        bg,
        textColor,
        { 'transform translate-y-3 opacity-0': loading },
        'bg-gradient-x p-[2px] text-md font-medium whitespace-nowrap uppercase rounded-full cursor-pointer transition-all duration-500'
      )}
      onClick={onClick}
    >
      <div className={cn(bg, 'rounded-full py-2 px-4')}>{children}</div>
    </button>
  );

Button.defaultProps = {
  className: ''
};

export default Buttons;
